<template>
  <header>
    <div class="nav">
      <a href="/" class="logo-link">
        <img
          class="logo"
          src="https://api.slater.co.nz/v/2f9a8bcc-b51f-4a18-be2f-3626fee11460.svg"
        />
      </a>

      <nav class="menu-col">
        <a href="/testimonials" class="nav-item"><div>Testimonials</div></a>
        <a href="/partners" class="nav-item"><div>Partners</div></a>
        <a href="/pricing" class="nav-item"><div>Pricing</div></a>
        <a href="/contact" class="nav-item"><div>Contact</div></a>
      </nav>

      <div class="mobile-menu" @click.prevent="toggleMenu">
        <svg height="20px" viewBox="0 -21 384 384" width="20px" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#213b55"
            d="m362.667969 0h-341.335938c-11.753906 0-21.332031 9.578125-21.332031 21.332031v42.667969c0 11.753906 9.578125 21.332031 21.332031 21.332031h341.335938c11.753906 0 21.332031-9.578125 21.332031-21.332031v-42.667969c0-11.753906-9.578125-21.332031-21.332031-21.332031zm0 0"
          />
          <path
            fill="#213b55"
            d="m362.667969 128h-341.335938c-11.753906 0-21.332031 9.578125-21.332031 21.332031v42.667969c0 11.753906 9.578125 21.332031 21.332031 21.332031h341.335938c11.753906 0 21.332031-9.578125 21.332031-21.332031v-42.667969c0-11.753906-9.578125-21.332031-21.332031-21.332031zm0 0"
          />
          <path
            fill="#213b55"
            d="m362.667969 256h-341.335938c-11.753906 0-21.332031 9.578125-21.332031 21.332031v42.667969c0 11.753906 9.578125 21.332031 21.332031 21.332031h341.335938c11.753906 0 21.332031-9.578125 21.332031-21.332031v-42.667969c0-11.753906-9.578125-21.332031-21.332031-21.332031zm0 0"
          />
        </svg>
      </div>
    </div>

    <Menu v-if="menuOpen" @toggleMenu="toggleMenu" />

    <div class="action-buttons">
      <a href="tel:078389700" class="action-btn call-btn">
        <div>07 838 9700</div>
      </a>

      <a
        href="https://login.xero.com/identity/user/login"
        target="_blank"
        class="action-btn xero-btn"
      >
        <div>Xero Login</div>
      </a>
    </div>
  </header>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import Menu from './Menu.vue';

const menuOpen = ref(false);

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

watch(menuOpen, (isOpen) => {
  document.body.style.overflow = isOpen ? 'hidden' : '';
});

onBeforeUnmount(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped>
/* Header */
header {
  background-color: #fff;
  height: 100px;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 100;
}

/* Logo */
.logo-link {
  display: flex;
}

.logo {
  width: 48px;
  height: 48px;
}

/* Nav menu */
.nav {
  display: flex;
  align-items: center;
}

.menu-col {
  display: flex;
  height: 100%;
  margin-left: 40px;
}

.nav-item {
  font-weight: 600;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  font-size: 20px;
  color: #172c40;
  margin-left: 40px;
}

/* Mobile Hamburger */
.mobile-menu {
  display: none;
  cursor: pointer;
  margin-left: 15px;
}

/* Desktop action buttons */
.action-buttons {
  display: flex;
}

.action-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 5px 20px;
  font-weight: 600;
  font-size: 15px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 15px;
  text-decoration: none;
}

.call-btn {
  background-color: #50dcaa;
  color: #183043;
  border: none;
}

.xero-btn {
  background-color: #fff;
  color: #183043;
  border: 2px solid rgba(33, 59, 85, 0.3);
}

/* Responsive */
@media only screen and (max-width: 768px) {
  header {
    padding: 0 20px;
  }

  .menu-col,
  .action-buttons {
    display: none;
  }

  .mobile-menu {
    display: flex;
  }

  .nav {
    justify-content: space-between;
    width: 100%;
  }
}
</style>
